import {mapMutations, mapState} from "vuex";

export default {
    data: function() {
        return {
            timesout: null,
        };
    },
    computed: {
        ...mapState([
            'infoMessage',
            'isLoading',
            'isSaving',
        ]),
    },

    methods: {
        ...mapMutations([
            'setInfoMessage',
            'clearInfoMessage',
            'setLoading',
            'clearLoading',
            'setSaving',
            'clearSaving',
        ]),
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/UsesInfoMessage.js